export default "__VITE_ASSET__DXeVK_nF__"